import * as React from "react";

import { ModalStateInfo } from "../IModalState";

import { ZeroReportingContainer } from "./ZeroReporting/ZeroReportingContainer";
import { PatchFufByAttachmentModalContainer } from "./PatchFufByAttachments/PatchFufByAttachmentContainer";
import { UploadSectionContainer } from "./UploadSection/UploadSectionContainer";
import { UploadExcelInTableModalContainer } from "./UploadExcelInTable/UploadExcelInTableContainer";
import { UploadXmlInTableContainer } from "./UploadXmlInTable/UploadXmlInTableContainer";
import { NdflInquiryUploadContainer } from "./NdflInquiryUpload/NdflInquiryUploadContainer";

export function mountModal(modalInfo: ModalStateInfo | undefined) {
    if (modalInfo == undefined || modalInfo.isOpen === false) {
        return null;
    }
    switch (modalInfo.modalName) {
        case "PatchFufByAttachment":
            return <PatchFufByAttachmentModalContainer />;
        case "LoadExcel":
            return <UploadExcelInTableModalContainer />;
        case "LoadXml":
            return <UploadXmlInTableContainer />;
        case "UploadSection":
            return <UploadSectionContainer />;
        case "NdflInquiryUpload":
            return <NdflInquiryUploadContainer />;
        case "ZeroReport":
            return <ZeroReportingContainer />;
        default:
            throw Error("modalName must be defined");
    }
}
